// src/pages/Certificate.jsx
import React, { useRef } from "react";
import html2canvas from "html2canvas";

const Certificate = () => {
  const certRef = useRef();

  const studentName = "Nitin Satya"; // Replace with dynamic name if using auth
  const course = "Cyber Security Internship";
  const date = new Date().toLocaleDateString();

  const handleDownload = async () => {
    const element = certRef.current;
    const canvas = await html2canvas(element);
    const link = document.createElement("a");
    link.download = "certificate.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  return (
    <div className="min-h-screen bg-[#0f172a] text-white flex flex-col items-center justify-center px-4 py-10">
      <h2 className="text-3xl font-bold text-[#bb86fc] mb-8 text-center">🎉 Your Internship Certificate</h2>

      {/* Certificate Card */}
      <div
        ref={certRef}
        className="bg-white text-black w-full max-w-2xl p-10 rounded-lg shadow-lg text-center relative"
      >
        <h3 className="text-2xl font-bold mb-4">Certificate of Completion</h3>
        <p className="text-lg mb-6">This certifies that</p>
        <h1 className="text-3xl font-bold text-purple-700">{studentName}</h1>
        <p className="mt-6">
          has successfully completed the <strong>{course}</strong> internship.
        </p>
        <p className="mt-2 text-sm text-gray-600">Issued on: {date}</p>

        {/* Signature */}
        <div className="mt-10 text-right pr-6">
          <p className="font-semibold">K N S STUDIOS</p>
          <p className="text-sm text-gray-500">Internship Coordinator</p>
        </div>

        {/* Border */}
        <div className="absolute inset-0 border-4 border-purple-600 rounded-lg pointer-events-none" />
      </div>

      <button
        onClick={handleDownload}
        className="mt-8 bg-green-600 px-6 py-2 rounded hover:bg-green-700 transition text-white"
      >
        📥 Download Certificate
      </button>
    </div>
  );
};

export default Certificate;
